import { Fab, Grid } from "@material-ui/core";
import { FC } from "react";
import { FaViber, FaVimeo, FaYelp } from "react-icons/fa";
import { IoLogoSnapchat } from "react-icons/io";
import {
  RiFacebookFill,
  RiInstagramLine,
  RiLineFill,
  RiLinkedinBoxFill,
  RiMapPinLine,
  RiPinterestFill,
  RiRedditFill,
  RiTelegramFill,
  RiTwitchFill,
  RiWhatsappFill,
  RiYoutubeFill
} from "react-icons/ri";

import {
  SiTiktok,
  SiZillow
} from "react-icons/si";
import { SocialNetworks } from "store/url-builder";
import { NewSocialProvider, SocialProvider } from "..";
import Calendly from "../Calendly";
import Eventbrite from "../Eventbrite";
import Realtor from "../Realtor";
import Threads from "../Threads";
import X from "../X";
import style from "./social-list.module.scss";

export const getSocialIcon = (
  provider: SocialProvider | NewSocialProvider,
  { width, height }: { width: number; height: number }
) => {
  switch (provider) {
    case SocialProvider.FACEBOOK:
      return <RiFacebookFill style={{ width, height }} color="#4267B2" />;
    case SocialProvider.INSTAGRAM:
      return <RiInstagramLine style={{ width, height }} color="#E1306C" />;
    case SocialProvider.PINTEREST:
      return <RiPinterestFill style={{ width, height }} color="#E60023" />;
    case SocialProvider.TWITTER:
      return <X style={{ width: "20px", height: "20px" }} color="#1DA1F2" />;
    case SocialProvider.LINKEDIN:
      return <RiLinkedinBoxFill style={{ width, height }} color="#0e76a8" />;
    case NewSocialProvider.LINKEDIN:
      return <RiLinkedinBoxFill style={{ width, height }} color="#0e76a8" />;
    case SocialProvider.YOUTUBE:
      return <RiYoutubeFill style={{ width, height }} color="#FF0000" />;
    case SocialProvider.SNAPCHAT:
      return <IoLogoSnapchat style={{ width, height }} color="#F9A825" />;
    case SocialProvider.REDDIT:
      return <RiRedditFill style={{ width, height }} color="#FF4500" />;
    case SocialProvider.LINE:
      return <RiLineFill style={{ width, height }} color="#00B900" />;
    case SocialProvider.TWITCH:
      return <RiTwitchFill style={{ width, height }} color="#6441A4" />;
    case SocialProvider.TELEGRAM:
      return <RiTelegramFill style={{ width, height }} color="#0088CC" />;
    case SocialProvider.VIBER:
      return <FaViber style={{ width, height }} color="#665CAC" />;
    case SocialProvider.TIKTOK:
      return <SiTiktok style={{ width, height }} color="#010101" />;
    case SocialProvider.WHATSAPP:
      return <RiWhatsappFill style={{ width, height }} color="#25D366" />;
    case SocialProvider.VIMEO:
      return <FaVimeo style={{ width, height }} color="#1AB7EA" />;
    case SocialProvider.THREADS:
      return <Threads style={{ width, height }} fill="#000000" />;
    case SocialProvider.EVENTBRITE:
      return <Eventbrite style={{ width, height }} fill="#F05537" />;
    case SocialProvider.YELP:
      return <FaYelp style={{ width, height }} color="#FF1A1A" />;
    case SocialProvider.CALENDLY:
      return <Calendly style={{ width, height }} fill="#006BFF" />;
    case SocialProvider.REALTOR:
      return <Realtor style={{ width, height }} fill="#C12F32" />;
    case SocialProvider.ZILLOW:
      return <SiZillow style={{ width, height }} color="#1B7AFF" />;
    default:
      return <RiMapPinLine style={{ width, height }} color="#666666" />;
  }
};

export interface SocialNetworkListProps {
  socialNetworks: SocialNetworks[];
  onItemClick?(item: SocialNetworks): void;
}

export const SocialNetworkList: FC<SocialNetworkListProps> = ({
  socialNetworks,
  onItemClick,
}) => {
  // Filter out Skype entries
  const filteredNetworks = socialNetworks.filter(
    (social) => social.networkName !== "Skype" && social.networkName !== "Skype ID"
  );

  return (
    <>
      {filteredNetworks.map((social) => {
        if (social.networkName.length === 0) return null;
        return (
          <Grid item key={social.networkName}>
            <Fab
              className={style.socialItem}
              onClick={() => onItemClick && onItemClick(social)}
              aria-label="add"
            >
              {getSocialIcon(
                social.networkName as SocialProvider | NewSocialProvider,
                { width: 30, height: 30 }
              )}
            </Fab>
          </Grid>
        );
      })}
    </>
  );
};
